<template>
    <div class="mb-2">
        <h1>{{text}}</h1>
        <v-divider></v-divider>
    </div>
</template>

<script>
    export default{
        name: 'WTitle',
        props: ['text']
    }
</script>

<style scoped>
    h1{
        font-weight: 200;
    }
</style>